import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

const GOLD = '#D4AF37';
const BG_CARD = '#0d1117';
const BORDER = 'rgba(255,255,255,0.07)';
const TEXT_SEC = '#6b7280';
const INPUT_BG = '#0a0f1e';

const cardStyle = { background: BG_CARD, border: `1px solid ${BORDER}`, borderRadius: 16, padding: 24, marginBottom: 16 };
const inputStyle = { width: '100%', background: INPUT_BG, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };
const btnGold = { background: GOLD, color: '#000', border: 'none', borderRadius: 10, padding: '12px 20px', fontWeight: 700, fontSize: 14, cursor: 'pointer' };
const btnGhost = { background: 'transparent', color: TEXT_SEC, border: `1px solid ${BORDER}`, borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };

export default function Referrals() {
  const [referrals, setReferrals] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ referrer_id: '', referred_name: '', referred_phone: '' });
  const [toast, setToast] = useState('');
  const [tab, setTab] = useState('leaderboard');

  useEffect(() => {
    load();
    api.get('/clients').then(r => setClients(r.data)).catch(() => {});
  }, []);

  function load() {
    api.get('/referrals').then(r => setReferrals(r.data)).catch(() => {});
    api.get('/referrals/leaderboard').then(r => setLeaderboard(r.data)).catch(() => {});
  }
  function showToast(msg) { setToast(msg); setTimeout(() => setToast(''), 3000); }

  async function logReferral(e) {
    e.preventDefault();
    try {
      await api.post('/referrals', { referrer_id: form.referrer_id, referred_name: form.referred_name, referred_phone: form.referred_phone });
      setForm({ referrer_id: '', referred_name: '', referred_phone: '' });
      setShowModal(false); load();
      showToast('Referral logged!');
    } catch { showToast('Error logging referral'); }
  }

  const medals = ['#1', '#2', '#3'];

  return (
    <AdminLayout>
      {toast && (
        <div style={{ position: 'fixed', top: 20, right: 20, background: BG_CARD, border: `1px solid ${GOLD}`, color: GOLD, padding: '12px 20px', borderRadius: 10, zIndex: 9999, fontWeight: 600 }}>{toast}</div>
      )}
      <div style={{ maxWidth: 800 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800, margin: 0 }}>Referrals</h1>
            <p style={{ color: TEXT_SEC, fontSize: 14, margin: '4px 0 0' }}>{referrals.length} total referrals tracked</p>
          </div>
          <button style={btnGold} onClick={() => setShowModal(true)}>+ Log Referral</button>
        </div>

        {showModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ ...cardStyle, width: '100%', maxWidth: 480, marginBottom: 0 }}>
              <h3 style={{ color: GOLD, margin: '0 0 20px', fontSize: 16 }}>Log Referral</h3>
              <form onSubmit={logReferral}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>REFERRER (existing client) *</label>
                    <select style={inputStyle} value={form.referrer_id} onChange={e => setForm({...form, referrer_id: e.target.value})} required>
                      <option value="">Select client...</option>
                      {clients.map(c => <option key={c.id} value={c.id}>{c.name} {c.phone ? `— ${c.phone}` : ''}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>REFERRED PERSON'S NAME *</label>
                    <input style={inputStyle} value={form.referred_name} onChange={e => setForm({...form, referred_name: e.target.value})} required placeholder="John Smith" />
                  </div>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>REFERRED PERSON'S PHONE</label>
                    <input style={inputStyle} value={form.referred_phone} onChange={e => setForm({...form, referred_phone: e.target.value})} placeholder="(561) 555-0100" />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button type="submit" style={btnGold}>Log Referral</button>
                  <button type="button" style={btnGhost} onClick={() => setShowModal(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div style={{ display: 'flex', gap: 0, marginBottom: 20, background: BG_CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: 4, width: 'fit-content' }}>
          {['leaderboard', 'all'].map(t => (
            <button key={t} onClick={() => setTab(t)} style={{
              background: tab === t ? GOLD : 'transparent', color: tab === t ? '#000' : TEXT_SEC,
              border: 'none', borderRadius: 8, padding: '8px 20px', fontWeight: 700, fontSize: 13, cursor: 'pointer', textTransform: 'capitalize',
            }}>{t === 'leaderboard' ? 'Leaderboard' : 'All Referrals'}</button>
          ))}
        </div>

        {tab === 'leaderboard' ? (
          <div style={cardStyle}>
            {leaderboard.length === 0 ? (
              <p style={{ color: TEXT_SEC, textAlign: 'center', padding: '24px 0' }}>No referrals logged yet.</p>
            ) : leaderboard.map((c, i) => (
              <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '12px 0', borderTop: i > 0 ? `1px solid ${BORDER}` : 'none' }}>
                <span style={{ fontSize: 24, width: 36, textAlign: 'center' }}>{medals[i] || `#${i + 1}`}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{c.name}</div>
                  <div style={{ color: TEXT_SEC, fontSize: 12 }}>{c.phone || ''}</div>
                </div>
                <div style={{ background: GOLD + '22', color: GOLD, border: `1px solid ${GOLD}44`, borderRadius: 8, padding: '4px 14px', fontWeight: 800, fontSize: 15 }}>
                  {c.referral_count} {c.referral_count === '1' ? 'referral' : 'referrals'}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={cardStyle}>
            {referrals.length === 0 ? (
              <p style={{ color: TEXT_SEC, textAlign: 'center', padding: '24px 0' }}>No referrals logged yet.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Referrer', 'Referred', 'Date'].map(h => (
                      <th key={h} style={{ color: TEXT_SEC, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', padding: '0 0 12px', textAlign: 'left', letterSpacing: '0.05em' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {referrals.map((r, i) => (
                    <tr key={r.id} style={{ borderTop: i > 0 ? `1px solid ${BORDER}` : 'none' }}>
                      <td style={{ padding: '12px 0', color: '#fff', fontWeight: 600, fontSize: 14 }}>{r.referrer_name || '—'}</td>
                      <td style={{ padding: '12px 0', color: TEXT_SEC, fontSize: 13 }}>
                        {r.referred_name || r.referred_client_name || '—'}
                        {r.referred_phone && <span style={{ display: 'block', fontSize: 12 }}>{r.referred_phone}</span>}
                      </td>
                      <td style={{ padding: '12px 0', color: TEXT_SEC, fontSize: 12 }}>
                        {new Date(r.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
